import {Component, inject, model, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {InsclExpiry, Page, UcepDataImportDto, UcepGroupRegisterParam} from "../../../../generated-model/model";
import {IgnoreNullHttpParams} from "../../../shared/commons/Ignore-null-http-params";
import {ConfirmDialogService} from "../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {filter} from "rxjs/operators";
import {ProgressionDialogService} from "../../../shared/commons/dialog/progression-dialog/progression-dialog.service";
import {UcepService} from "./service/ucep.service";
import {ToastService} from "../../../shared/commons/toast/toast-service";
import {JsonPipe, NgIf} from "@angular/common";
import {ThaiDateTimePipe} from "../../../shared/commons/thai-datetime.pipe";
import {
  SelectMastercupSearchService
} from "../../../shared/components/select-mastercup-search/select-mastercup-search.service";
import {
  SelectInsclExpiryRightComponent
} from "../../../shared/components/select-inscl-expiry-right/select-inscl-expiry-right.component";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";
import {SelectInsclExpiryComponent} from "../../../shared/components/select-inscl-expiry/select-inscl-expiry.component";
import {InsclExpiryResource} from "../../../service/InsclExpiryResource";

@Component({
  selector: 'app-ucep',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbPagination,
    ThaiDateTimePipe,
    SelectInsclExpiryRightComponent,
    SharedCommonModule,
    SelectInsclExpiryComponent,
    NgIf,
    JsonPipe
  ],
  templateUrl: './ucep.component.html',
  styleUrl: './ucep.component.scss'
})
export class UcepComponent implements OnInit {

  private confirmDialogService = inject(ConfirmDialogService);
  private progressionDialogService = inject(ProgressionDialogService);
  private ucepService = inject(UcepService)
  private toastService: ToastService = inject(ToastService);
  selectMastercupSearchService = inject(SelectMastercupSearchService)
  private insclExpiryResource = inject(InsclExpiryResource);
  pageData: Page<UcepDataImportDto> = {number: 0, size: 30, content: []};
  param: UcepGroupRegisterParam = {status:1};
  checkedAll: boolean = false;
  checkDate = model<string>(undefined);
  checkTime = model<string>(undefined);

  ngOnInit(): void {
    this.search();
  }

  search(page: number = 0) {
    let param = IgnoreNullHttpParams.fromObject(this.param)
      .append('page', page)
      .append('size', this.pageData?.size)

    this.ucepService.search(param).subscribe(res => {
      res.content.forEach(item => {
        if (item.transDate) {
          const [date, time] = item.transDate.split("T");
          item['date'] = date;
          item['time'] = time;
        }
      })
      this.pageData = res;
    })
  }

  selectMastercup(ucep?: UcepDataImportDto) {
    this.selectMastercupSearchService.open({catm: ucep?.mastercup?.catm})
      .subscribe(mastercup => {
        console.log('selected mastercup: ', mastercup);
        ucep.mastercup = mastercup;
      });
  }

  save() {
    let ucepDataImportDtos = this.elementChecked();
    this.confirmDialogService.open({content: 'ยืนยันการลงทะเบียน'})
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังบันทึกข้อมูล..."});
          this.ucepService.save(ucepDataImportDtos)
            .subscribe({
              next: e => {
                this.toastService.showSuccess("บันทึกข้อมูลเรียบร้อยแล้ว");
                this.search()
              },
              error: err => {
                this.progressionDialogService.close();
              },
              complete: () => {
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  elementChecked() {
    return this.pageData.content.filter(e => e['checked'])
  }

  checkAll(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.checkedAll = true;
      this.pageData.content.forEach(item => {
        if (item.disabled == false) {
          item['checked'] = true;
        }
      })
    } else {
      this.pageData.content.forEach(item => {
        if (item.disabled == false) {
          item['checked'] = false;
        }
      })
    }
  }

  checked(item: UcepDataImportDto, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      item['checked'] = true;
    } else {
      item['checked'] = false;
      this.checkedAll = false;
    }
  }

  clear() {
    this.param = {}
    this.checkedAll = false;
    this.pageData = {number: 0, size: 10, content: []};
    this.search();
  }

  onSubInsclChange(parseBirthDate, item: UcepDataImportDto, insclExpiry: InsclExpiry) {
    item.expDate = ''
    item.subInscl = insclExpiry.inscl;
    this.insclExpiryResource.find(parseBirthDate, insclExpiry?.inscl?.inscl)
      .subscribe(subInsclExpiry => {
        if (subInsclExpiry) {
          item.insclExpiry = subInsclExpiry
          if (subInsclExpiry?.expireDateResult?.minExpireDate == subInsclExpiry?.expireDateResult?.maxExpireDate) {
            item.expDate = subInsclExpiry?.expireDateResult?.minExpireDate
          } else if (item?.insclExpiry?.expiryPolicy == 'NOEXP') {
            item.expDate = undefined
          } else {
            item.expDate = subInsclExpiry?.expireDateResult?.minExpireDate
          }
        }
      });
  }

  rightChange(item: UcepDataImportDto) {
    item.expDate = ''
    item.insclExpiry = undefined
    item.subInscl = undefined
  }

  canReprocess(item: UcepDataImportDto) {
    return item?.canRegis === 'N';
  }

  reProcess(item: UcepDataImportDto) {
    const pid = item?.personalData?.personalId;
    if (!pid) {
      return;
    }

    item['reprocessing'] = true;
    this.ucepService.reProcess(pid).subscribe({
      next: () => {
        this.toastService.showSuccess('ประมวลผลใหม่เรียบร้อยแล้ว');
        this.search(this.pageData.number);
      },
      error: () => {
        item['reprocessing'] = false;
      },
      complete: () => {
        item['reprocessing'] = false;
      }
    });
  }


  changeDate(item: UcepDataImportDto, event: any) {
    item.transDate = `${event}T${item['time']}`;
  }

  changeTime(item: UcepDataImportDto, event: any) {
    item.transDate = `${item['date']}T${event}`;
  }

  formatValidationMessage(validationMessage?: string) {
    if (!validationMessage) {
      return '';
    }
    return validationMessage
      .replace(' เนื่องจาก ', '\nเนื่องจาก ')
      .replace(' แต่ ', '\nแต่ ');
  }
}
